import HttpService from "./http-service";
import Gender from "../entities/gender";

export default class GenderService extends HttpService {
  public async getGenders(): Promise<Gender[]> {
    const response = await this.httpClient.get<Gender[]>('genders');

    return response.data
  }
}

